import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { Component, Children, cloneElement, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../H5/H5.js';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import { Trail, config, animated, interpolate } from 'react-spring/renderprops.cjs';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../H4/H4.js';
import { ListItem } from './ListItem.js';
import './ListItemMeta.js';

const ListDiv = styled(Div)`
  width: 100%;
  overflow-y: auto;
  position: relative;
  flex: 1 1 0%;
  padding-bottom: 100px;
`;

class List extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "keys", []);
    _defineProperty(this, "renderItem", (item, index) => {
      const {
        dataSource,
        renderItem,
        itemKey
      } = this.props;
      let key = '';
      if (typeof itemKey === 'function') {
        key = itemKey(dataSource[index]);
      } else if (typeof itemKey === 'string') {
        key = dataSource[itemKey];
      }
      if (!key) {
        key = `listItem-${index}`;
      }
      this.keys.push(key);
      return renderItem(item, index);
    });
  }
  render() {
    const {
      dataSource,
      isAnimationEnabled,
      mode,
      styles
    } = this.props;
    let childrenContent;
    if (dataSource.length > 0) {
      const items = dataSource.map((item, index) => this.renderItem(item, index));
      const childrenList = Children.map(items, (child, index) => {
        return /*#__PURE__*/cloneElement(child, {
          key: this.keys[index],
          isCompact: mode === 'compact'
        });
      });
      childrenContent = childrenList;
    }
    return /*#__PURE__*/createElement(ListDiv, _extends({
      className: "list-wrapper"
    }, styles.root), isAnimationEnabled && childrenContent && /*#__PURE__*/createElement(Trail, {
      items: childrenContent,
      native: true,
      config: config.stiff,
      from: {
        opacity: 0,
        y: -10
      },
      to: {
        opacity: 1,
        y: 0
      },
      keys: this.keys
    }, item => function AnimatedItem({
      y,
      opacity
    }) {
      return /*#__PURE__*/createElement(animated.div, {
        className: "box",
        style: {
          opacity,
          transform: interpolate([y], cy => `translate3d(0,${cy}%,0)`)
        }
      }, item);
    }), !isAnimationEnabled && childrenContent);
  }
}
_defineProperty(List, "defaultProps", {
  mode: 'default',
  dataSource: [],
  isAnimationEnabled: false,
  styles: {}
});
_defineProperty(List, "Item", ListItem);

export default List;
